import { memo } from "react";
import classNames from "classnames";
import { CellContextWithDragHandle } from "@design-system/ViewTable/ViewTable";
import { DragHandle6DotIcon } from "@icons";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { NestedEditorRow } from "../nestedRowTypes";
import styles from "../ChartOfAccountsTemplateNestedEditor.module.scss";

// Six-dot drag handle, rendered only on draggable rows (custom groups + account
// rows). Structural section / built-in tier rows are fixed, so they get no
// handle. Stops click propagation so grabbing the handle never toggles
// expand/selection.
export const NestedDragHandleCell = memo(
    ({
        row,
        rowDragHandle,
    }: CellContextWithDragHandle<NestedEditorRow, unknown>) => {
        const { kind } = row.original;
        const isDraggable = kind === "account" || kind === "group";
        // `rowDragHandle` is absent when drag is disabled (e.g. while a
        // search/filter narrows the tree and ViewTable renders the non-sortable
        // branch); hide the handle then so it doesn't show an inert grab cursor.
        if (!isDraggable || !rowDragHandle) {
            return null;
        }
        return (
            <span
                aria-label="Reorder"
                className={classNames(
                    viewTableStyles.showOnHover,
                    styles.dragHandle,
                )}
                {...rowDragHandle.attributes}
                {...rowDragHandle.listeners}
                onClick={(event) => event.stopPropagation()}
            >
                <DragHandle6DotIcon />
            </span>
        );
    },
);

NestedDragHandleCell.displayName = "NestedDragHandleCell";
